import { render, staticRenderFns } from "./StockWithoutLocation.vue?vue&type=template&id=4fc0300a"
import script from "./StockWithoutLocation.vue?vue&type=script&lang=js"
export * from "./StockWithoutLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports